import { AnnouncementType, IAnnouncementModel } from '../../../interfaces/IAnnoucementModel';
import {
    GET_USER_ANNOUNCEMENTS_KEY,
    useGetUserAnnouncements,
} from '../../../pages/announcement/useGetUserAnnouncements';
import { useEffect, useState } from 'react';

import { AnnouncementDetail } from './AnnouncementDetail';
import { useLocation } from 'react-router-dom';
import { useQueryClient } from 'react-query';

export function PageAnnouncements() {
    const queryClient = useQueryClient();
    const location = useLocation();
    const userAnnouncementsQuery = useGetUserAnnouncements(!!location.pathname);
    const [pageAnnouncements, setPageAnnouncements] = useState<IAnnouncementModel[]>([]);

    const handleRemoveAnnouncement = (guid: string) => {
        queryClient.setQueryData(
            [GET_USER_ANNOUNCEMENTS_KEY],
            userAnnouncementsQuery?.data?.filter((f) => f.guid !== guid)
        );
    };

    useEffect(() => {
        let pathToMatch = location.pathname.includes('/zone/')
            ? location.pathname.replace(/\/zone\/[a-f0-9-]+/, '')
            : location.pathname;
        if (pathToMatch === '') {
            pathToMatch = '/';
        }
        setPageAnnouncements(
            userAnnouncementsQuery.data?.filter(
                (a) => a.announcementTypeId === AnnouncementType.Page
            ) ?? []
        );
    }, [location.pathname, userAnnouncementsQuery.data]);

    if ((pageAnnouncements?.length ?? 0) === 0) {
        return null;
    }

    return (
        <div className="sticky-top" >
            {pageAnnouncements?.map((announcement: IAnnouncementModel) => {
                return (
                    <AnnouncementDetail
                        key={announcement.guid}
                        announcement={announcement}
                        onRemoveAnnouncement={handleRemoveAnnouncement}
                    />
                );
            })}
        </div>
    );
}
